import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const KEY = "folio.ground";
const ORDER = ["auto", "light", "dark"];

const GroundContext = createContext(null);

export const useGround = () => useContext(GroundContext);

/**
 * Polarity switch. "auto" lets each chapter keep its authored tone; "light" and
 * "dark" force the whole sheet to one ground via a data attribute the token
 * layer outranks chapter classes with. Persisted, because a reader who flips it
 * meant it.
 */
export const GroundProvider = ({ children }) => {
  const [ground, setGround] = useState("auto");

  useEffect(() => {
    const stored = window.localStorage.getItem(KEY);
    if (stored && ORDER.includes(stored)) setGround(stored);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (ground === "auto") root.removeAttribute("data-ground");
    else root.setAttribute("data-ground", ground);
    window.localStorage.setItem(KEY, ground);
  }, [ground]);

  const cycle = useCallback(() => {
    setGround((prev) => ORDER[(ORDER.indexOf(prev) + 1) % ORDER.length]);
  }, []);

  const value = useMemo(() => ({ ground, cycle, setGround }), [ground, cycle]);

  return <GroundContext.Provider value={value}>{children}</GroundContext.Provider>;
};
